import React, { useMemo, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useSelector, useStore } from 'react-redux'
import { Button, LoadingIndicator, StatusSection } from '../../../../components'
import { TableViewVirtualized } from '../../common/TableViewVirtualized'
import { getTableHeader } from '../../common/tableHeaders'
import { selectInputState } from '../../store/slices/input.slice'
import {
  selectOutputDataFootNotes,
  selectOutputDataSummary,
  selectOutputStatus,
} from '../../store/slices/output.slice'

const Output = (props) => {
  const { isLoading, msgLevel, msgHeader, msgBody } = useSelector(selectOutputStatus)

  return (
    <div className="outputSectionWrapper" {...props}>
      <h2 className="sectionFlag -output">Output</h2>
      <div className="outputSection">
        <div className="container-fluid">
          {/* <DebugOutput /> */}
          {isLoading ? (
            <LoadingIndicator />
          ) : msgBody ? (
            <StatusSection
              statusLevel={msgLevel}
              statusIcon={'assets/images/icons/sst-icon-info.svg'}
              statusHeader={msgHeader}
              statusBody={msgBody}
            />
          ) : (
            <OutputSummary />
          )}
        </div>
      </div>
    </div>
  )
}

function OutputSummary() {
  const store = useStore()
  const summary = useSelector(selectOutputDataSummary)
  const footNotes = useSelector(selectOutputDataFootNotes)

  const { summaryHeader, defaultSorted } = useMemo(() => {
    const state = store.getState()
    const input = selectInputState(state)
    return getTableHeader(input, summary)
  }, [summary]) // isLoading || isError || msgBody ? {} : getTableHeader(input)

  const renderedFootNotes = useMemo(
    () =>
      footNotes
        ?.filter((tag) => tag.startsWith('<li>')) // prevent render unexpected tags
        .join('')
        .replace(/\\/g, '') ?? null,
    [footNotes],
  )

  return (
    <>
      <section id="pfdOutputSummaryTable">
        <TableViewVirtualized
          title={'Summary'}
          columns={summaryHeader}
          serverData={summary}
          sortBy={defaultSorted}
          disableSorting={false}
          disableSearch={false}
          disableToggleSwitch
          disableDownloadCSV={false}
        />
      </section>

      {renderedFootNotes && (
        <>
          <h4 className="tableNotes">Table Notes</h4>
          <ol className="tableNotes">{ReactHtmlParser(renderedFootNotes)}</ol>
        </>
      )}
    </>
  )
}

// /**
//  * NOTE: for development only
//  */
// // eslint-disable-next-line no-unused-vars
// function DebugOutput() {
//   const { input, output, status } = useSelector((state) => state.calculation)
//   const [showMore, setShowMore] = useState(false)
//   const handleShowMore = () => {
//     setShowMore(!showMore)
//   }

//   return (
//     <>
//       <Button variant="text" onClick={handleShowMore}>
//         <img data-src="" className="iconic iconic-md injectSVG" alt="" />
//         <span className="button__text">
//           {showMore ? 'Hide Calculation Detail' : 'Show Calculation Detail'}
//         </span>
//       </Button>

//       {showMore ? (
//         <section>
//           <pre>
//             calculation input: {JSON.stringify(input, undefined, 2)}
//             <br />
//             calculation status: {JSON.stringify(status, undefined, 2)}
//             <br />
//             calculation output: {JSON.stringify(output, undefined, 2)}
//           </pre>
//         </section>
//       ) : null}
//     </>
//   )
// }

export default Output
